import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IContactTrackingDialogData {
  entityId: string;
  campaignId: string;
  contactItem?: { _typename: string, id: string };
}

@Component({
  selector: 'app-contact-tracking-dialog',
  templateUrl: './contact-tracking.dialog.html',
  styleUrls: ['./contact-tracking.dialog.scss'],
})
export class ContactTrackingDialog {
  static open(dialog: MatDialog, config: MatDialogConfig<IContactTrackingDialogData>) {
    return dialog.open<ContactTrackingDialog, IContactTrackingDialogData, any>
      (ContactTrackingDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<ContactTrackingDialog, any>,
    @Inject(MAT_DIALOG_DATA) public data: IContactTrackingDialogData
  ) {
  }


  close(data?: any) {
    this.dialogRef.close(data);
  }
}
